export const platformNames = {
  tiktok: 'TikTok',
  instagram: 'Instagram',
  facebook: 'Facebook',
  youtube: 'YouTube',
};

export function formatNumber(value) {
  if (value === null || value === undefined || value === '') return '—';
  const number = Number(value);
  return Number.isFinite(number) ? number.toLocaleString('zh-CN') : String(value);
}

export function compactNumber(value) {
  if (value === null || value === undefined || value === '') return '—';
  const number = Number(value);
  if (number >= 100_000_000) return `${(number / 100_000_000).toFixed(2)}亿`;
  if (number >= 10_000) return `${(number / 10_000).toFixed(1)}万`;
  return formatNumber(number);
}

export function formatDate(value) {
  if (!value) return '尚未采集';
  return new Intl.DateTimeFormat('zh-CN', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(value));
}

export function formatDateOnly(value) {
  if (!value) return '日期未知';
  return new Intl.DateTimeFormat('zh-CN', {
    timeZone: 'Asia/Shanghai',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date(value)).replaceAll('/', '-');
}

export function videoDisplayTitle(video) {
  const title = video?.title?.trim() || video?.description?.trim();
  return title || `${platformNames[video?.platform] ?? '视频'} · ${video?.platformVideoId ?? '内容待补充'}`;
}

export function comparableViewSnapshots(snapshots, platform) {
  const items = snapshots ?? [];
  if (platform !== 'instagram' || !items.length) return items;
  const latest = items.reduce((current, item) => (
    !current || new Date(item.collectedAt) > new Date(current.collectedAt) ? item : current
  ), null);
  return latest?.actorId ? items.filter((item) => item.actorId === latest.actorId) : items;
}

export function buildViewTrend(snapshots, { width = 600, height = 180, padding = 24 } = {}) {
  const items = (snapshots ?? [])
    .filter((snapshot) => snapshot?.collectedAt && snapshot.metrics?.views != null
      && snapshot.metrics.views !== '' && Number.isFinite(Number(snapshot.metrics.views)))
    .map((snapshot) => ({
      id: snapshot.id,
      collectedAt: snapshot.collectedAt,
      views: Number(snapshot.metrics.views),
    }))
    .sort((left, right) => new Date(left.collectedAt) - new Date(right.collectedAt));
  const values = items.map((item) => item.views);
  const min = values.length ? Math.min(...values) : 0;
  const max = values.length ? Math.max(...values) : 0;
  const range = Math.max(max - min, 1);
  const plotWidth = width - padding * 2;
  const plotHeight = height - padding * 2;
  const points = items.map((item, index) => ({
    ...item,
    x: padding + (items.length <= 1 ? plotWidth / 2 : index * plotWidth / (items.length - 1)),
    y: padding + (max - item.views) / range * plotHeight,
  }));
  return {
    items,
    points,
    polyline: points.map((point) => `${point.x.toFixed(1)},${point.y.toFixed(1)}`).join(' '),
    min,
    max,
    width,
    height,
  };
}

export function statusMeta(status) {
  return {
    success: { label: '已更新', color: 'green' },
    partial: { label: '部分成功', color: 'orange' },
    pending: { label: '待采集', color: 'gray' },
    running: { label: '执行中', color: 'arcoblue' },
    temporarily_failed: { label: '采集失败', color: 'red' },
    unavailable: { label: '不可用', color: 'red' },
    private_or_restricted: { label: '访问受限', color: 'red' },
    failed: { label: '失败', color: 'red' },
  }[status] ?? { label: status || '未知', color: 'gray' };
}
